import React, { useEffect, useRef, useState } from "react";
// import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { fetchCheckIDVerifyData } from "../../../Redux/features/Reports/CheckIDVerify/CheckIDVerifySlice";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import { SkeletonTable } from "../../../reuseableComponents/SkeletonTable";

import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import sortIcon from "../../../Assests/Category/SortingW.svg";
import { SortTableItemsHelperFun } from "../../../helperFunctions/SortTableItemsHelperFun";
import { Link } from "react-router-dom";
import PasswordShow from "../../../Common/passwordShow";
import NoDataFound from "../../../reuseableComponents/NoDataFound";
import useDelayedNodata from "../../../hooks/useDelayedNoData";
import { format } from "date-fns";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";
const orderEnv = (type) => {
  if (type === "Online Order") {
    return "Online";
  }
  if (type === "Store Order") {
    return "Offline";
  } else {
    return type;
  }
};

const StyledTable = styled(Table)(({ theme }) => ({
  padding: 2, // Adjust padding as needed
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--qv-bg-253338, #253338)",
    color: theme.palette.common.white,
    fontFamily: "CircularSTDMedium !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
  [`&.${tableCellClasses.table}`]: {
    fontSize: 14,
    fontFamily: "CircularSTDBook !important",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    // backgroundColor: "var(--qv-bg-f5f5f5, #F5F5F5)",
  },
  "& td, & th": {
    border: "none",
  },
}));

const CheckIDVerifyList = (props) => {
  const { page = 1, hasMore = false, fetchMoreData, isLoading = false, initialLoading = false } = props;
  const dispatch = useDispatch();
  const {
    LoginGetDashBoardRecordJson,
    LoginAllStore,
    userTypeData,
    GetSessionLogin,
  } = useAuthDetails();
  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const [allCheckIDVerifyData, setallCheckIDVerifyData] = useState([]);
  const showNoData = useDelayedNodata(allCheckIDVerifyData)
  const AllCheckIDVerifyDataState = useSelector(
    (state) => state.CheckIDVerifyList
  );
  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;
  const prevParamsRef = useRef("");

  useEffect(() => {
    const start = props?.selectedDateRange?.start_date || "";
    const end = props?.selectedDateRange?.end_date || "";
    const orderType = props?.OrderTypeData ?? "";
    const orderSource = props?.OrderSourceData ?? "";
    const paramKey = `${start}|${end}|${String(orderType)}|${String(orderSource)}`;

    if (!start || !end) return; // wait until date range is selected
    if (prevParamsRef.current === paramKey) return; // no-op for same params
    prevParamsRef.current = paramKey;
    if (props.onInitialFetch) {
      props.onInitialFetch();
    }
  }, [
    props?.selectedDateRange?.start_date,
    props?.selectedDateRange?.end_date,
    props?.OrderTypeData,
    props?.OrderSourceData,
  ]);
  const renderLoader = () => {
    return (
      <table>
        <tbody>
          {[1, 2, 3, 4, 5].map((row) => (
            <tr key={row} style={{ background: "var(--qv-bg-a0x0x0x40, rgba(0, 0, 0, 0.04))" }}>
              {["", "", "", "", ""].map((col, index) => (
                <td key={index}>
                  <Skeleton />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  useEffect(() => {
    if (
      !AllCheckIDVerifyDataState.loading &&
      AllCheckIDVerifyDataState.CheckIDVerifyData
    ) {
      setallCheckIDVerifyData(AllCheckIDVerifyDataState.CheckIDVerifyData);
    } else {
      setallCheckIDVerifyData([]);
    }
  }, [
    AllCheckIDVerifyDataState,
    AllCheckIDVerifyDataState.loading,
    AllCheckIDVerifyDataState.CheckIDVerifyData,
  ]);

  const formatDate = (dateString) => {
    const [month, day, year] = dateString.split("-");
    const date = new Date(year, month - 1, day);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };
  const formatTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":");
    const date = new Date();
    date.setHours(hours, minutes, seconds);
    const options = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    return date.toLocaleTimeString("en-US", options);
  };

  const tableRow = [
    { type: "date", name: "merchant_date", label: "Date" },
    { type: "time", name: "merchant_time", label: "Time" },
    { type: "str", name: "full_name", label: "Employee" },
    { type: "id", name: "order_id", label: "Order ID" },
    { type: "str", name: "name", label: "Item Name" },
  ];
  const [sortOrder, setSortOrder] = useState("asc");
  const sortByItemName = (type, name) => {
    const { sortedItems, newOrder } = SortTableItemsHelperFun(
      allCheckIDVerifyData,
      type,
      name,
      sortOrder
    );
    setallCheckIDVerifyData(sortedItems);
    setSortOrder(newOrder);
  };

  // Build CSV data/headers and export controls dynamically
  useEffect(() => {
    const headers = [
      { id: "merchant_date", name: "Date" },
      { id: "merchant_time", name: "Time" },
      { id: "full_name", name: "Employee" },
      { id: "order_id", name: "Order ID" },
      { id: "name", name: "Item Name" },
    ];

    // CSV data + headers
    if (props?.setCSVData && props?.setCSVHeaders) {
      const CSVData = (allCheckIDVerifyData || []).map((row) => ({
        merchant_date:
          row?.merchant_date && !isNaN(new Date(row.merchant_date))
            ? format(new Date(row.merchant_date), "MM/dd/yyyy")
            : "",
        merchant_time: row?.merchant_time ? formatTime(row.merchant_time) : "",
        full_name: row?.full_name || "",
        order_id: row?.order_id || "",
        name: row?.name || "",
      }));
      const CSVHeaders = headers.map((h) => ({ label: h.name, key: h.id }));
      try {
        props.setCSVData(CSVData);
        props.setCSVHeaders(CSVHeaders);
      } catch (_) {
        // no-op
      }
    }

    // Export headers for backend
    if (typeof props?.setExportHeaders === "function") {
      try {
        props.setExportHeaders(headers.map((h) => h.name));
      } catch (_) {}
    }

    // Enable/disable export button
    if (typeof props?.setExportAvailable === "function") {
      props.setExportAvailable(
        Array.isArray(allCheckIDVerifyData) && allCheckIDVerifyData.length > 0
      );
    }
  }, [allCheckIDVerifyData]);
  return (
    <>
      <div className="mb-10">
        <InfiniteScroll
          dataLength={allCheckIDVerifyData.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={isLoading && <div className="custom-table">{renderLoader()}</div>}
        >
          <TableContainer
            sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
          >
            <StyledTable sx={{ minWidth: 500 }} aria-label="customized table">
              <TableHead>
                {tableRow.map((item, idx) => (
                  <StyledTableCell key={idx}>
                    <button
                      className="flex items-center"
                      onClick={() => sortByItemName(item.type, item.name)}
                    >
                      <p>{item.label}</p>
                      <img src={sortIcon} alt="" className="pl-1" />
                    </button>
                  </StyledTableCell>
                ))}
              </TableHead>
              <TableBody>
                {initialLoading && allCheckIDVerifyData.length === 0 ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={5}>
                      <div className="custom-table">{renderLoader()}</div>
                    </StyledTableCell>
                  </StyledTableRow>
                ) : allCheckIDVerifyData && allCheckIDVerifyData.length >= 1 ? (
                  allCheckIDVerifyData.map((CheckData, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>
                        <p>
                          {CheckData.merchant_date && !isNaN(new Date(CheckData.merchant_date))
                            ? format(
                                new Date(CheckData.merchant_date),
                                "MM/dd/yyyy"
                              )
                            : ""}
                        </p>
                      </StyledTableCell>
                      <StyledTableCell>
                        <p>{CheckData.merchant_time ? formatTime(CheckData.merchant_time) : "N/A"}</p>
                      </StyledTableCell>
                      <StyledTableCell>
                        <p className="">{CheckData.full_name}</p>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Link
                          to={`/order/store-reporting/order-summary/${merchant_id}/${CheckData.order_id}`}
                          target="_blank"
                        >
                          <p className="text-[#0A64F9] underline underline-offset-[3px]">
                            {CheckData?.order_id}
                          </p>
                        </Link>
                      </StyledTableCell>
                      <StyledTableCell>
                        <p className="">{CheckData.name}</p>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  !initialLoading && allCheckIDVerifyData.length === 0 && (
                    <StyledTableRow>
                      <StyledTableCell colSpan={5}>
                        <div className="inv-no-record">
                          <NoDataFound message="No Data Found" />
                        </div>
                      </StyledTableCell>
                    </StyledTableRow>
                  )
                )}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </InfiniteScroll>
      </div>
    </>
  );
};

export default CheckIDVerifyList;
